module.exports = __webpack_public_path__ + "img/ValuePlus.b643d478.png";